import { fetchApi } from "../utils/fetchApi";

export function fetchVehicledetails({ filter = {}, options = {} }) {
  return fetchApi({ base: 'v2', url: `vehicledetails?vin=${filter.vin}`, filter: {}, options });
}

